import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/expenseService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import { getLedgerTypes } from "../../services/expenseTypeService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class ExpenseForm extends Form {
  state = {
    imageUrl: false,
    data: {
      expense_type_id: "",
      description: "",
      cost: "",
    },
    paymentDate: new Date(),
    visas: [],
    errors: {},
  };

  schema = {
    id: Joi.string(),

    expense_type_id: Joi.number().required().label("Expense Type"),
    description: Joi.string().required().label("Description"),
    cost: Joi.number().required().label("Cost"),
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const { data: visasAccounts } = await getLedgerTypes();
    const visas = [{ id: "", name: "Select" }, ...visasAccounts];

    this.setState({ visas, blocking: false });
  }

  handleChangePaymentDate = (date) => {
    this.setState({
      paymentDate: date,
    });
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      //const data = { ...this.state.data };

      let formData = new FormData();
      formData.append("description", this.state.data.description);
      formData.append("cost", this.state.data.cost);
      formData.append("expense_type_id", this.state.data.expense_type_id);

      var event = new Date(this.state.paymentDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);

      formData.append("payment_date", date);
      formData.append("attachment", this.state.imageUrl);
      await saveSingle(formData);

      toast.success("Expense has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/expenses");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.visa_id)
          errors.expense_type_id = ex.response.data.errors.expense_type_id;

        if (ex.response.data.errors.description)
          errors.description = ex.response.data.errors.description;

        if (ex.response.data.errors.cost)
          errors.cost = ex.response.data.errors.cost;
        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/Expenses.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add expense</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/expenses")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add expense</h3>
              <p>Provide the information below to add the expense.</p>
              <label>Payment Date</label>
              <br />
              <DatePicker
                selected={this.state.paymentDate}
                onChange={this.handleChangePaymentDate}
                className="input"
              />
              {this.renderSelect(
                "expense_type_id",
                "Select type ",
                this.state.visas
              )}
              {this.renderInput("cost", "Cost", "text")}
              {this.renderInput("description", "Description", "text")}
              <label>Attachment</label>
              <input
                className="input"
                type="file"
                onChange={this.onChangeFile}
              />

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default ExpenseForm;
